<template>
  <div
    class="
      w-full
      sm:w-auto
      pt-3.5
      pb-3
      sm:pt-0
      sm:pb-0
      absolute
      -bottom-16
      left-0
      sm:static
      rounded
      sm:rounded-none
      bg-todoBackground-light
      dark:bg-todoBackground-dark
      shadow-todoShadowLight
      dark:shadow-todoShadowDark
      sm:shadow-none
      flex flex-row flex-grow
      justify-center
      bg-white
    "
  >
    <button
      @click="$emit('activate-filter', 'all')"
      :class="[
        this.activeFilter === 'all'
          ? 'text-activeButton'
          : 'text-filterText-light hover:text-filterTxtHover-light dark:text-filterText-dark dark:hover:text-filterTxtHover-dark',
        'sm:ml-4 text-sm font-bold font-josefin transition-all duration-300',
      ]"
    >
      All
    </button>
    <button
      @click="$emit('activate-filter', 'uncompleted')"
      :class="[
        this.activeFilter === 'uncompleted'
          ? 'text-activeButton'
          : 'text-filterText-light hover:text-filterTxtHover-light dark:text-filterText-dark dark:hover:text-filterTxtHover-dark',
        'ml-4 text-sm font-bold font-josefin transition-all duration-300',
      ]"
    >
      Active
    </button>
    <button
      @click="$emit('activate-filter', 'completed')"
      :class="[
        this.activeFilter === 'completed'
          ? 'text-activeButton'
          : 'text-filterText-light hover:text-filterTxtHover-light dark:text-filterText-dark dark:hover:text-filterTxtHover-dark',
        'ml-4 text-sm font-bold font-josefin transition-all duration-300',
      ]"
    >
      Completed
    </button>
  </div>
</template>
<script>
export default {
  name: "Filters",
  props: {
    activeFilter: String,
  },
};
</script>